import { useEffect, useState } from "react";
import PouchDB from "pouchdb-browser";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { useDoc } from "use-pouchdb";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { format } from "small-date";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@mui/material/Paper";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import HomeIcon from "@mui/icons-material/Home";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TabPanel from "./components/TabPanel";
import { postQSC } from "./../utilities/datalayer";
import StoreSelector from "./components/StoreSelector";
import { currentQuestionnaire, questionnaire, current, completed } from "./../utilities/state";

const localDB = new PouchDB('delfornoqsc', { revs_limit: 1 });

function TabArea(props) {

    const { value, index, item } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`}>
            {value === index && (
                <TabPanel {...item} />
            )}
        </div>
    );
}

function CreateQSC() {

    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(0);
    const [currentCompleted, setCurrentCompleted] = useState({
        total: 198,
        completed: 0,
        percentage: 0
    });

    const [hasStore, setHasStore] = useState(false);
    const [store, setStore] = useState({
        storeName: 'Select a franchise'
    });

    const setCurrent = useSetRecoilState(current);
    const _completed = useRecoilValue(completed);
    const _current = useRecoilValue(current);
    const _questionnaire = useRecoilValue(questionnaire);
    const _currentQuestionnaire = useRecoilValue(currentQuestionnaire);
    const [updated, setUpdated] = useState('');
    const { doc, loading } = useDoc(_current);

    const navigator = useNavigate();

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (e, value) => {
        setValue(value);
    };

    const handleStoreChange = async (store) => {

        setStore(store);

        if (!doc && !loading) {

            let qsc = {
                _id: 'QSC-' + _currentQuestionnaire.questionnaireId + '-' + store.storeId,
                questionnaireId: _currentQuestionnaire.questionnaireId,
                name: _currentQuestionnaire.name,
                storeId: store.storeId,
                answers: []
            }
            await localDB.put(qsc);

            setCurrent('QSC-' + _currentQuestionnaire.questionnaireId + '-' + store.storeId);
            setHasStore(true);

        }
    }

    const handleUpload = async () => {

        let _doc = _.cloneDeep(doc);

        _.each(_doc.answers, (answer) => {
            answer.images = JSON.stringify(answer.images);
        });

        let response = await postQSC(_doc);
        let updated = new Date(response.updated);
        updated = format(updated, 'DDD dd MMMM yyyy, hh:mm a');
        setUpdated(updated);
        setOpen(false);
    }

    const Logout = async () => {
        localStorage.setItem('access_token', '');
        navigator("/");
    }

    const GoHome = async () => {
        navigator("/");
    }

    useEffect(() => {

        let total = 198;

        let completed = {
            total,
            completed: _completed,
            percentage: (_completed / total) * 100
        }

        setCurrentCompleted(completed);

        if (_current) {
            setHasStore(true);
        }

    }, [_completed]);

    return (
        <>
            <Container sx={{ padding: 1, backgroundColor: '#dedede' }}>
                <Box sx={{ flexGrow: 1 }}>
                    <AppBar position="static">
                        <Toolbar sx={{ backgroundColor: '#000' }}>
                            <Box onClick={GoHome}>
                                <img src={process.env.PUBLIC_URL + "/logo.png"} style={{ width: '80px' }} alt="Del Forno" />
                            </Box>
                            <Box>
                                <Typography component="div" sx={{ flexGrow: 1, ml: 1 }}>
                                    Quality Control Audit System
                                </Typography>
                                <Typography component="div" sx={{ flexGrow: 1, ml: 1, fontSize: 10 }}>
                                    0.16 04/10/2023
                                </Typography>
                            </Box>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginLeft: 8, marginRight: 8 }} onClick={() => setOpen(true)}>
                                <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ padding: 0, ml: '2px' }}>
                                    <CloudUploadIcon />
                                </IconButton>
                                <Typography sx={{ fontSize: 12 }}>Upload</Typography>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginLeft: 8 }} onClick={() => GoHome()}>
                                <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ padding: 0, ml: '4px' }}>
                                    <HomeIcon />
                                </IconButton>
                                <Typography sx={{ fontSize: 12 }}>Home</Typography>
                            </div>
                        </Toolbar>
                    </AppBar>
                </Box>
                <Paper elevation={2} sx={{ backgroundColor: '#fff', padding: 2, mt: 2 }}>
                    <Typography variant="subtitle1" component="div" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
                        {_currentQuestionnaire ? doc?.name : _currentQuestionnaire.name}
                    </Typography>
                    <Typography variant="subtitle1" component="div" sx={{ flexGrow: 1 }}>
                        Quality Control Audit - {currentCompleted.completed}/{currentCompleted.total} ({parseInt(currentCompleted.percentage) + '%'})
                    </Typography>
                </Paper>
                {updated !== '' &&
                    <Typography variant="caption" component="div" sx={{ flexGrow: 1, color: '#2d2d2d', textAlign: 'right', paddingTop: '2px' }}>
                        Last Uploaded: {updated}
                    </Typography>
                }
                <Paper elevation={2} sx={{ backgroundColor: '#fff' }}>
                    <Box>
                        <StoreSelector handleStoreChange={handleStoreChange} />
                    </Box>
                    {
                        hasStore && <>
                            <Box sx={{ margin: 2, marginLeft: 4, marginRight: 4 }}>
                                <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto">
                                    {
                                        _questionnaire.map((item) => {
                                            return <Tab label={item.questionSection} id={'tab' + item.questionSectionId} key={item.questionSectionId} style={{ outline: 'none' }} />
                                        })
                                    }
                                </Tabs>
                            </Box>
                            {
                                _questionnaire.map((item, index) => {
                                    return <TabArea value={value} index={item.questionSectionId - 1} key={item.questionSectionId} item={item} />
                                })
                            }
                        </>
                    }
                    <div style={{ height: 30 }}></div>
                </Paper>
            </Container>
            <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Upload to Cloud?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to upload this audit to the cloud? This will overwrite any older versions.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>No</Button>
                    <Button onClick={() => handleUpload()} autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}


export default CreateQSC;
